import request from '@/utils/request'

let CustomerApi = {
    /*  客户详细信息 */
    getCustomerData(data) {
        return request._post('/shop/plus.customer.customer/getCustomerData', data);
    },
    /* 客户资源列表 */
    customerList(data) {
        return request._post('/shop/plus.customer.customer/customerList', data);
    },
    /* 省列表 */
    provinceList(data) {
        return request._get('/shop/plus.customer.customer/provinceList', data);
    },
    /* 市列表 */
    city_list(data) {
        return request._get('/shop/plus.customer.customer/cityList', data);
    },
    /* 区域列表 */
    region_list(data) {
        return request._get('/shop/plus.customer.customer/regionList', data);
    },
    /* 保存编辑客户资源 */
    get_edit(data) {
        return request._post('/shop/plus.customer.customer/getEdit', data);
    },
    /* 删除客户资源 */
    del_customer(data) {
        return request._post('/shop/plus.customer.customer/delCustomer', data);
    },
    /* 保存客户配置 */
    put_setting(data) {
        return request._post('/shop/plus.customer.customer/putSetting', data);
    },
    /* 获取客户配置 */
    get_setting(data) {
        return request._post('/shop/plus.customer.customer/getSetting', data);
    },
    /* 保存自定义配置 */
    put_open(data) {
        return request._post('/shop/plus.customer.customer/putOpen', data);
    },
    /* 获取自定义配置 */
    get_open(data) {
        return request._get('/shop/plus.customer.customer/getOpen', data);
    },

    /* 获取会员等级 */
    user_list(data) {
        return request._get('/shop/plus.customer.customer/getUserList', data);
    },

    /* 获取会员 */
    get_bind(data) {
        return request._post('/shop/plus.customer.customer/getBind', data);
    },

    /* 上传文件  */
    get_upload(formData) {
        return request._upload('/shop/plus.customer.customer/excel_upload', formData);
    },

    /* 获取后台域名 */
    uploadUrl(data) {
        return request._get('/shop/plus.customer.customer/upload_url', data);
    },

}
export default CustomerApi;



// WEBPACK FOOTER //
// ./src/api/customer.js